<div #container
  class="wrapper iax {{theme}}"
  [class.fullscreen]="fullscreen || mobileFullscreen"
  [style.--mobile-viewport-height.px]="mobileViewportHeight"
  [style.--mobile-viewport-offset-top.px]="mobileViewportOffsetTop"
  [style.--mobile-viewport-width.px]="mobileViewportWidth"
  [style.--mobile-viewport-offset-left.px]="mobileViewportOffsetLeft"
  *ngIf="!this.signalRIniciando && !this.recuperandoIp">
  
  <div id="chat" class="chat-box" *ngIf="visible" [@fadeInOut]="visible" 
    (@fadeInOut.done)="onChatAnimationDone($event)"
    [style.height.px]="fullscreen || mobileFullscreen ? null : height"
    [style.right.px]="fullscreen || mobileFullscreen ? null : right"
    [style.left.px]="fullscreen || mobileFullscreen ? null : left">

    <div #chat class="chat-box-header" [cdkDropListDisabled]="limite" [attr.draggable]="!fullscreen" (drag)="redimensionar($event)"
      (mousemove)="callResizeChat($event)">
      <div class="items-chat-box-header">
        <div class="operador-chat-box-header">
          <div class="header-avatar">
            <chat-avatar [image]="_chatService.operator.avatar" [nome]="_chatService.operator.name"
              [size]="38"></chat-avatar>
            <span class="header-status-ponto" *ngIf="habilitarStatusOnline"
              [class.online]="_chatService.operator.status == 'online'"></span>
          </div>
          <div class="header-identidade">
            <div class="operator-name">{{_chatService.operator.name}}</div>
            <div class="header-subtitulo" *ngIf="onlineLabel">{{onlineLabel}}</div>
          </div>
        </div>

        <div class="header-acoes">
          <button *ngIf="!fullscreen" type="button" class="header-acao header-acao-desktop" (click)="toggleChat()"
            aria-label="Fechar conversa">
            <mat-icon svgIcon="close"></mat-icon>
          </button>
          <button *ngIf="!fullscreen" type="button" class="header-acao header-acao-mobile" (click)="toggleChat()"
            aria-label="Minimizar conversa">
            <mat-icon svgIcon="keyboard_arrow_down"></mat-icon>
          </button>
          <chat-export *ngIf="chatFinalizado" [dadosConversa]="messages" [chatFinalizado]="chatFinalizado" [catalogo]="catalogo" [mensagemGuid]="mensagemGuidFinalizada"></chat-export>
        </div>
      </div>
    </div>
    <div class="chat-box-main">
      <div class="chat-message-bottom" #bottom></div>
      <div *ngIf="avaliarPrechat()" class="alinhamentoPrechat">
        <span class="tamanhoSpan">
          <div *ngFor="let message of prechat" class="boxPrechat" (click)="sendMessage({message})">
            {{message}}
          </div>
        </span>
      </div>
      <ng-container *ngFor="let message of messages; trackBy: trackMensagem">
        <div *ngIf="message.type === 'evento'" class="chat-evento" [@mensagemEntrando]>
          <span class="chat-evento-linha"></span>
          <span class="chat-evento-texto">{{message.text}}</span>
          <span class="chat-evento-linha"></span>
        </div>

        <div *ngIf="message.type !== 'evento'"
          class="chat-message" [class.chat-message-received]="message.type === 'received'" [@mensagemEntrando]
          [class.chat-message-sent]="message.type === 'sent'">
          <div>
            <chat-avatar *ngIf="message.type === 'received'" [image]="message.from.avatar" [nome]="message.from.name"
              [size]="30" class="chat-message-from-avatar"></chat-avatar>

            <div *ngIf="!message.anexo" class="chat-message-text">
              {{message.text}}            
            </div>

            <div *ngIf="message.botoes != null && message.botoes.length > 0">
              <ng-container *ngFor="let item of message.botoes">
                <div [ngSwitch]="item.tipo">
                  <div *ngSwitchCase="'bloqueado'" class="chat-message-text button-item-estilo button-item-inerte">
                    {{ item.texto }}
                  </div>

                  <a *ngSwitchCase="'link'" class="chat-message-text button-item-estilo button-item-link" [href]="item.url" target="_blank" rel="noopener noreferrer">
                    {{ item.texto }}
                  </a>

                  <button *ngSwitchDefault class="chat-message-text button-item-estilo" (click)="sendMessage({message : item.texto})">
                    {{ item.texto }}
                  </button>
                </div>
              </ng-container>
            </div>

            <div class="flex flex-row items-center">
              <div *ngIf="message.anexo && message.anexoConteudo.falha" class="box-icon-error">
                <mat-icon svgIcon="error" class="icon-anexo-error"></mat-icon>
                <span class="tooltiptext">{{message.anexoConteudo.falha}}</span>
              </div>

              <div *ngIf="message.anexo">
                <ng-container
                  *ngIf="!message.anexoConteudo.type.startsWith('audio') && !message.anexoConteudo.type.endsWith('ogg') && !message.anexoConteudo.name.endsWith('opus')">
                  <div class="chat-message-text" style="cursor: pointer;"
                    [ngClass]="{'anexo-erro': message.anexo && message.anexoConteudo.falha}"
                    (click)="OnClickAnexo($event,message)">

                    <!--  Visual anexo imagens -->
                    <ng-container *ngIf="message.anexoConteudo.type.startsWith('image')">

                      <div class="chat-message-image">

                        <img
                          crossorigin="anonymous"
                          [src]="message.anexoConteudo.urlArquivo"
                          [alt]="getNomeAnexo(message.anexoConteudo.name)"
                          [title]="getNomeAnexo(message.anexoConteudo.name)"
                          class="chat-message-image-preview"
                        />

                        <div
                          *ngIf="message.anexoConteudo.legenda"
                          class="chat-message-image-legend">
                          {{message.anexoConteudo.legenda}}
                        </div>

                      </div>

                    </ng-container>

                    <!--  Visual anexo documento -->
                    <ng-container *ngIf="!message.anexoConteudo.type.startsWith('image')">

                      <div class="chat-message-anexo anexo-row">

                        <img
                          class="anexo-thumb anexo-thumb-arquivo"
                          [src]="message.anexoConteudo.urlThumbnail || getThumbnailAnexo(message.anexoConteudo.name)"
                          [alt]="getNomeAnexo(message.anexoConteudo.name)"
                          (error)="recarregarThumb($event, message.anexoConteudo)"
                        />

                        <div class="anexo-info">

                          <div
                            class="anexo-nome"
                            [title]="getNomeAnexo(message.anexoConteudo.name)">
                            {{getNomeAnexo(message.anexoConteudo.name)}}
                          </div>

                          <div class="anexo-dados">

                            <span class="anexo-dados-tipo">
                              {{getExtensaoAnexo(message.anexoConteudo.name)}}
                            </span>

                            <span class="anexo-dados-tamanho ml-1.5">
                              {{formataBytes(message.anexoConteudo.size)}}
                            </span>

                          </div>

                        </div>

                      </div>

                      <div
                        *ngIf="message.anexoConteudo.legenda"
                        class="anexo-legend">
                        {{message.anexoConteudo.legenda}}
                      </div>

                    </ng-container>

                  </div>
                </ng-container>

                <ng-container
                  *ngIf="message.anexoConteudo.type.startsWith('audio') || message.anexoConteudo.type.endsWith('ogg') || message.anexoConteudo.name.endsWith('opus')">
                  <audio controls=""  class="chat-message-text" style="max-width: 240px !important;">
                    <source src="{{message.anexoConteudo.urlArquivo}}" type="audio/ogg">
                    Seu browser não suporte a escuta de audio.
                  </audio>
                </ng-container>

              </div>

            </div>

          </div>
          <div class="chat-message-date">
            {{formatarData(message.date)}}
          </div>
        </div>
      </ng-container>
    </div>
    <div class="chat-box-footer" *ngIf="!(fullscreen && chatFinalizado)">
      <chat-input (send)="sendMessage($event)" (dismiss)="toggleChat()" (composerChange)="onComposerChange()" [focus]="focus"></chat-input>

    </div>
    <div class="chat-box-encerrado" *ngIf="fullscreen && chatFinalizado">
      <mat-icon svgIcon="lock" class="chat-box-encerrado-icone"></mat-icon>
      Este atendimento foi encerrado.
    </div>
  </div>
  <div *ngIf="visible_bottom">

    <div class="links-rapidos" *ngIf="!visible && linksRapidos.length > 0"
      [class.links-rapidos-visivel]="mostrarLinks"
      [class.links-rapidos-esquerda]="orientacaoLado === 'left'"
      [style.bottom.px]="offsetLinks"
      [style.right]="orientacaoLado === 'right' ? orientacaoValor : null"
      [style.left]="orientacaoLado === 'left' ? orientacaoValor : null"
      (mouseenter)="mostrarLinks = true"
      (mouseleave)="mostrarLinks = false">
      <button type="button" class="link-rapido" *ngFor="let link of linksRapidos"
        (click)="abrirLinkRapido(link)">
        <span class="link-rapido-legenda">{{link.legenda}}</span>
        <mat-icon svgIcon="open_in_new" class="link-rapido-icone"></mat-icon>
      </button>
    </div>

    <button #chatButton *ngIf="!visible" class="chat-button alinhamento" (click)="toggleChat()" ativo="false"
      (mouseenter)="mostrarLinks = true" (mouseleave)="mostrarLinks = false"
      [ngClass]="{'bolha': designModelo == 'bolha', 'barra': designModelo == 'barra'}">
      <span *ngIf="designModelo == 'bolha'" [@fadeIn]>
        <svg class="b24-crm-button-icon b24-crm-button-icon-active" width="28" height="29"
          xmlns="http://www.w3.org/2000/svg">
          <path class="b24-crm-button-chat-icon"
            d="M25.99 7.744a2 2 0 012 2v11.49a2 2 0 01-2 2h-1.044v5.162l-4.752-5.163h-7.503a2 2 0 01-2-2v-1.872h10.073a3 3 0 003-3V7.744zM19.381 0a2 2 0 012 2v12.78a2 2 0 01-2 2h-8.69l-5.94 6.453V16.78H2a2 2 0 01-2-2V2a2 2 0 012-2h17.382z"
            fill=" #FFFFFF" fill-rule="evenodd"></path>
        </svg>
      </span>
      <span class="labelBarra" *ngIf="designModelo == 'barra'">{{onlineLabel}}</span>
    </button>
  </div>
</div>